<template>
  <div class="vx-auto-suggest">
    <div class="flex items-center relative">
      <!-- Input -->
      <vs-input
        ref="input"
        :placeholder="placeholder"
        :class="inputClassses"
        class="z-50"
        icon-pack="feather"
        icon="icon-search"
        icon-no-border
        v-model="searchQuery"
        @keyup.esc="escPressed"
        @keyup.up="increaseIndex(false)"
        @keyup.down="increaseIndex"
        @keyup.enter="suggestionSelected"
        @focus="updateInputFocus"
        @blur="updateInputFocus(false)"
      />
    </div>

    <!-- Group List -->

    <ul
      v-if="showSuggestion"
      ref="scrollContainer"
      :class="{ hidden: !inputFocused }"
      class="auto-suggest-suggestions-list py-4 pl-5 z-50 rounded-lg mt-2 shadow-lg overflow-x-hidden"
      @mouseenter="insideSuggestions = true"
      @mouseleave="insideSuggestions = false"
      @focus="updateInputFocus"
      @blur="updateInputFocus(false)"
      tabindex="-1"
    >
      <li>جستجو در</li>
      <li
        ref="grp_list"
        v-for="item in items"
        :key="item.name"
        class="auto-suggest__suggestion-group-container py-3"
        @click="
          inputInit();
          $emit('input', '');
          showSuggestion = false;
        "
      >
        <span class="nav-link flex items-center" @click="serch(item)">
          <feather-icon class="w-5 h-5 mr-1" :icon="item.icon" />
          {{ $t(item.i18n) || item.name }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue';
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
export default {
  props: {
    placeholder: {
      type: String,
      default: "جستجو ..",
    },
    data: {
      type: Object,
      required: true,
    },
    initalData: {
      type: Object,
      default: () => new Object(),
    },
    inputClassses: {
      type: [String, Object, Array],
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    searchLimit: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      searchQuery: "",
      filteredData: {},
      currentSelected: -1,
      inputFocused: false,
      insideSuggestions: false,
      navMenuItems: navMenuItems,
      showSuggestion: false,
      names: [
        "ConsumerSingleBills",
        "ConsumerGroupBills",
        "Bills",
        "PaidBills",
        "ConsumerTransactions",
        "MerchantTransactions",
        "AllTransactions",
        "Merchants",
        "DraftMerchants",
        "Consumers",
        "CommissionGroups",
        "CustomSettingGroups",
        "Users",
        "Roles",
      ],
      items: [
        //  {
        //   icon:"DownloadIcon",
        //   title:"قبض‌های دریافتی",
        //   path:'/bill/consumer-bills'
        // },
        // {
        //   icon:"UploadIcon",
        //   title:"قبض‌های صادر شده",
        //   name:'Bills'
        // },
        // {
        //   icon:"TrendingUpIcon",
        //   title:"تراکنش ها",
        //   path:""
        // },
      ],
    };
  },
  watch: {
    // UPDATE SUGGESTIONS LIST
    searchQuery(val) {
      this.showSuggestion = true;
      this.$emit("input", val);

      if (val == "") {
        this.inputInit();
      } else {
        let queried_data = {};
        const data_grps = Object.keys(this.data);

        data_grps.forEach((grp, i) => {
          queried_data[data_grps[i]] = this.filter_grp(this.data[grp]);
        });

        // Check if any of group has at least one queried item
        if (!Object.values(queried_data).some((obj) => obj.length)) {
          this.currentSelected = -1;
        }

        this.filteredData = queried_data;
      }
    },
    autoFocus(val) {
      if (val) this.focusInput();
      else this.searchQuery = "";
    },
    filteredData(val) {
      // Auto Select first item if it's not item-404
      let grp_index = null;

      for (let [index, grp_suggestions] of Object.values(val).entries()) {
        if (grp_suggestions.length) {
          grp_index = index;
          break;
        }
      }

      if (grp_index != null) this.currentSelected = grp_index + ".0";
    },
  },
  methods: {
    serch(item) {
      this.$router.replace({
        path: item.url,
        name: item.url.name,
        query: { f: this.searchQuery },
      });
      //this.$set();
      //this.$router.go();
      //Vue.forceUpdate();
    },
    escPressed() {
      this.$emit("closeSearchbar");
      this.searchQuery = "";
    },
    filter_grp(grp) {
      let exactEle = grp.data.filter((item) => {
        return item[grp.key]
          .toLowerCase()
          .startsWith(this.searchQuery.toLowerCase());
      });
      let containEle = grp.data.filter((item) => {
        return (
          !item[grp.key]
            .toLowerCase()
            .startsWith(this.searchQuery.toLowerCase()) &&
          item[grp.key].toLowerCase().indexOf(this.searchQuery.toLowerCase()) >
            -1
        );
      });
      return exactEle.concat(containEle).slice(0, this.searchLimit);
    },
    inputInit() {
      if (
        Object.entries(this.initalData).length === 0 &&
        this.initalData.constructor === Object
      ) {
        this.filteredData = {};
      } else {
        this.filteredData = this.initalData;
      }
    },
    updateInputFocus(val = true) {
      if (val) {
        if (this.searchQuery == "") this.inputInit();
        setTimeout(() => {
          this.inputFocused = true;
        }, 100);
      } else {
        if (this.insideSuggestions) return;
        setTimeout(() => {
          this.inputFocused = false;
        }, 100);
        this.escPressed();
      }
    },
    suggestionSelected() {
      if (this.currentSelected > -1) {
        const [grp_index, item_index] = this.currentSelected.split(".");

        const grp_of_selected_item = Object.keys(this.data)[grp_index];
        const selected_item = this.filteredData[grp_of_selected_item][
          item_index
        ];

        this.$emit("selected", { [grp_of_selected_item]: selected_item });

        this.searchQuery = "";
      }
    },
    increaseIndex(val = true) {
      const [grp_i, item_i] = this.currentSelected.split(".");

      const grp_arr = Object.entries(this.filteredData);
      const active_grp_total_items = grp_arr[grp_i][1].length;

      if (val) {
        // If active item is not of last item in grp
        if (active_grp_total_items - 1 > item_i) {
          this.currentSelected = grp_i + "." + (Number(item_i) + 1);

          // If active item grp is not last in grp list
        } else if (grp_i < grp_arr.length - 1) {
          this.currentSelected = Number(grp_i) + 1 + ".0";
        }
      } else {
        // If active item is not of first item in grp
        if (Number(item_i)) {
          this.currentSelected = grp_i + "." + (Number(item_i) - 1);

          // If active item grp  is not first in grp list
        } else if (Number(grp_i)) {
          this.currentSelected =
            Number(grp_i) - 1 + "." + (grp_arr[grp_i - 1][1].length - 1);
        }
      }
    },
    focusInput() {
      this.$refs.input.$el.querySelector("input").focus();
    },
  },
  mounted() {
    this.items = this.navMenuItems.filter((x) => this.names.includes(x.name));
    if (this.autoFocus) this.focusInput();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxAutoSuggest.scss";
</style>
